import React from 'react';

const Footer = () => {
  return (
    <footer 
      className="text-gray-800 py-12 relative" 
      style={{ 
        backgroundColor: '#ffffff',
        borderTop: '0.25px solid #228b22'  // ULTRA-THIN 1px GREEN LINE
      }}
    >
      <div className="max-w-6xl mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {/* About Section */}
          <div className="flex flex-col">
            <h3 
              className="text-xl font-bold mb-4"
              style={{
                color: '#228b22',
                background: 'linear-gradient(45deg, #2f4f2f, #9acd32, #228b22)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text'
              }}
            >
              Tanzania Yetu Travels
            </h3>
            <p className="text-gray-700 text-sm mb-6 leading-relaxed">
              Your trusted partner for unforgettable safari adventures in Tanzania. Explore Africa's wild beauty with our expert guides.
            </p>
            <div className="flex gap-4 mt-auto">
              {[
                { href: 'https://www.facebook.com/africanadventures', icon: 'fab fa-facebook-f', label: 'Facebook' },
                { href: 'https://www.instagram.com/african_adventures?igsh=YzljYTk1ODg3Zg== ', icon: 'fab fa-instagram', label: 'Instagram' },
                { href: 'https://x.com/Africana2011', icon: 'fab fa-twitter', label: 'Twitter' }
              ].map((social, index) => (
                <a
                  key={index}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={social.label}
                  className="w-10 h-10 rounded-full flex items-center justify-center border border-green-800 hover:bg-green-50 transition-all duration-300"
                >
                  <i 
                    className={social.icon}
                    style={{
                      color: '#228b22',
                      background: 'linear-gradient(45deg, #2f4f2f, #9acd32, #228b22)',
                      WebkitBackgroundClip: 'text',
                      WebkitTextFillColor: 'transparent',
                      backgroundClip: 'text'
                    }}
                  ></i>
                </a>
              ))}
            </div>
          </div>

          {/* Contact Us */}
          <div className="flex flex-col">
            <h3 
              className="text-xl font-bold mb-4"
              style={{
                color: '#228b22',
                background: 'linear-gradient(45deg, #2f4f2f, #9acd32, #228b22)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text'
              }}
            >
              Contact Us
            </h3>
            <ul className="space-y-4">
              <li className="flex items-start">
                <i 
                  className="fas fa-phone mt-1 mr-3 flex-shrink-0" 
                  style={{
                    color: '#228b22',
                    background: 'linear-gradient(45deg, #2f4f2f, #9acd32, #228b22)',
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',
                    backgroundClip: 'text'
                  }}
                ></i>
                <span className="text-gray-700 text-sm">+255 753 182 737</span>
              </li>

              <li className="flex items-start">
                <i 
                  className="fas fa-envelope mt-1 mr-3 flex-shrink-0" 
                  style={{
                    color: '#228b22',
                    background: 'linear-gradient(45deg, #2f4f2f, #9acd32, #228b22)',
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',
                    backgroundClip: 'text'
                  }}
                ></i>
                <a
                  href="mailto:safaris@tanzania-yetutravellers.com"
                  className="text-gray-700 text-sm hover:underline footer-email"
                  style={{ 
                    textTransform: 'lowercase',
                    fontFamily: 'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
                    letterSpacing: 'normal'
                  }}
                >
                  safaris@tanzania-yetutravellers.com
                </a>
              </li>

              <li className="flex items-start">
                <i 
                  className="fas fa-map-marker-alt mt-1 mr-3 flex-shrink-0" 
                  style={{
                    color: '#228b22',
                    background: 'linear-gradient(45deg, #2f4f2f, #9acd32, #228b22)',
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',
                    backgroundClip: 'text'
                  }}
                ></i>
                <span className="text-gray-700 text-sm">Moshi, Kilimanjaro. Tanzania.</span>
              </li>
            </ul>
          </div>

          {/* Newsletter */}
          <div className="flex flex-col">
            <h3 
              className="text-xl font-bold mb-4"
              style={{
                color: '#228b22',
                background: 'linear-gradient(45deg, #2f4f2f, #9acd32, #228b22)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text'
              }}
            >
              Stay Updated
            </h3>
            <p className="text-gray-700 text-sm mb-4 leading-relaxed">
              Subscribe for travel tips and exclusive offers.
            </p>
            <div className="flex flex-col sm:flex-row gap-2">
              <input
                type="email"
                placeholder="enter your email"
                className="flex-1 p-3 rounded-md sm:rounded-l-md sm:rounded-r-none bg-white text-gray-800 border border-gray-300 focus:outline-none focus:ring-2 focus:ring-green-800 text-sm"
                style={{ 
                  textTransform: 'lowercase',
                  fontFamily: 'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
                }}
              />
              <button className="bg-green-800 text-white px-6 py-3 rounded-md sm:rounded-l-none sm:rounded-r-md hover:bg-green-700 transition-colors duration-300 text-sm font-medium whitespace-nowrap">
                Subscribe
              </button>
            </div>
          </div>
        </div>

        <hr className="border-gray-300 my-8" />

        <div className="text-center text-gray-600 text-sm">
          <p>© {new Date().getFullYear()} Tanzania Yetu Travels. African Adventure Travellers. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;